document.addEventListener('DOMContentLoaded', function() {
  var apiEndPoint = "aagasketapi.azurewebsites.net";
  //var apiEndPoint = "localhost:7146";
 
  var searchInput = document.getElementById('keySearchInput');
  var searchButton = document.getElementById('keySearchButton');
    //  const apiEndPoint = "localhost:7146";

    searchInput.addEventListener('keydown', function(event) {
      if (event.key === 'Enter') {
          event.preventDefault(); // Prevent form submission if inside a form
          searchButton.click(); // Trigger the search button click event
      }
    });
    function showLoading() {
        const loadingSpinner = document.getElementById('loadingSpinner4');
        loadingSpinner.style.display = 'block';
    }
    function hideLoading() {
        const loadingSpinner = document.getElementById('loadingSpinner4');
        loadingSpinner.style.display = 'none';
    }
      // Consolidated fetch function with error handling
      async function fetchApiData(url, options = {}) {
        try {
            const response = await fetch(url, {
              headers: {
                'xuserid': getCookieValue('xuserid')
              },
                credentials: 'include',
                ...options,
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const responseData = await response.json();
            // Set the 'xuserid' cookie with the value from the response
            document.cookie = `xuserid=${responseData.xuserid}; path=/`;
          
            return responseData;
        } catch (error) {
            throw new Error(`Error during fetch: ${error.message}`);
        }
    }
    document.getElementById('keySearchButton').addEventListener('click', function() {
      performSearch();
  });
  
  document.getElementById('keySearchInput').addEventListener('keydown', function(event) {
      if (event.key === 'Enter') {
          performSearch();
      }
  });
  
  function performSearch() {
      // Get the value from the input field
      const key = document.getElementById('keySearchInput').value;
  
      // Show the loading spinner
      document.getElementById('loadingSpinner4').style.display = 'inline-block';
  
      // Make the API request
      fetch(`https://${apiEndPoint}/AutoInfoSearchNZ/GetSmartSearch?partNumber=${encodeURIComponent(key)}`)
          .then(response => response.json())
          .then(data => {
              // Hide the loading spinner
              document.getElementById('loadingSpinner4').style.display = 'none';
  
              // Update the results container
              const resultsContainer = document.getElementById('resultsContainer4');
              resultsContainer.innerHTML = ''; // Clear previous results
  
              // Check if vrqResult is available and is an array
              if (data && data.model && Array.isArray(data.model.vrqResult)) {
                  // Create the table element
                  const table = document.createElement('table');
                  table.classList.add('table', 'table-striped');
  
                  // Create the table header
                  const headerRow = table.insertRow();
                  const headers = ['Make', 'Model', 'Year', 'Series', 'Chassis', 'Engine', 'Transmission', 'Body Style'];
                  headers.forEach(header => {
                      const headerCell = document.createElement('th');
                      headerCell.textContent = header;
                      headerRow.appendChild(headerCell);
                  });
  
                  // Create rows for each vehicle
                  data.model.vrqResult.forEach(vehicle => {
                      const row = table.insertRow();
  
                      const makeCell = row.insertCell();
                      makeCell.textContent = vehicle.make;
  
                      const modelCell = row.insertCell();
                      modelCell.textContent = vehicle.model;
  
                      const yearCell = row.insertCell();
                      yearCell.textContent = vehicle.year;
  
                      const seriesCell = row.insertCell();
                      seriesCell.textContent = vehicle.series;
  
                      const chassisCell = row.insertCell();
                      chassisCell.textContent = vehicle.chassis;
  
                      const engineCell = row.insertCell();
                      engineCell.textContent = vehicle.engine;
  
                      const transmissionCell = row.insertCell();
                      transmissionCell.textContent = vehicle.transmission;
  
                      const bodyStyleCell = row.insertCell();
                      bodyStyleCell.textContent = vehicle.bodyStyle;
                  });
  
                  const bodyRows = table.querySelectorAll('tr:not(:first-child)');
                  bodyRows.forEach(row => {
                      row.classList.add('clickable', 'cursor-pointer');
                      row.addEventListener('click', (event) => {
                          event.stopPropagation();
  
                          // Get the intended row element reliably:
                          const intendedRow = event.target.closest('tr');
  
                          if (intendedRow) {
                              const rowIndex = intendedRow.rowIndex;
                              let adjustedIndex = rowIndex - 1; // Account for header and potential extra rows
  
                              // Adjust for additional rows:
                              if (table.querySelectorAll('tr:not(:first-child):not(:last-child)').length > bodyRows.length) {
                                  adjustedIndex--;
                              }
  
                              // Validate index:
                              if (adjustedIndex >= 0 && adjustedIndex < data.model.vrqResult.length) {
                                  const rowData = data.model.vrqResult[adjustedIndex];
                                  showLoading();
  
                                  // Redirect to the other page
                                  const apiUrl = `https://${apiEndPoint}/AutoInfoSearchNZ/GetSearchResultsByKey?vehicleId=${rowData.vehicleIdEncrypted}`;
                                  fetchApiData(apiUrl)
                                      .then(data => {
                                          if (data) {
                                              document.getElementById('vehicle-search-result').style.display = 'none';
                                              populatePageWithData(data.model, 'resultsContainer4');
                                              document.getElementById('resultDiv').style.display = 'block';
                                              document.getElementById('noPartsFound4').style.display = 'none';
                                          } else {
                                              document.getElementById('noPartsFound4').style.display = 'block';
                                              document.getElementById('resultDiv').style.display = 'none';
                                          }
                                          hideLoading();
                                      });
  
                                  // Highlight the selected row
                                  const rows = table.querySelectorAll('tr');
                                  rows.forEach(row => row.classList.remove('selected'));
                                  intendedRow.classList.add('selected');
                              } else {
                                  console.error("Invalid row index:", adjustedIndex); // Handle invalid index
                              }
                          } else {
                              console.error("Could not determine row index from event target."); // Handle cases where intended row is not found
                          }
                      });
                  });
  
                  resultsContainer.appendChild(table);
                  resultsContainer.style.display = "block";
                  bodyRows.forEach(row => row.classList.add('clickable-row'));
              } else {
                  const noResultsElement = document.createElement('div');
                  noResultsElement.className = 'no-results';
                  noResultsElement.textContent = 'No results found';
                  resultsContainer.appendChild(noResultsElement);
              }
          })
          .catch(error => {
              console.error('Error:', error);
              document.getElementById('loadingSpinner4').style.display = 'none';
              const errorElement = document.createElement('div');
              errorElement.className = 'error-message';
              errorElement.textContent = 'An error occurred while fetching data';
              document.getElementById('resultsContainer4').appendChild(errorElement);
          });
  }
  
});
